// Import Tailwind tokens + Inter font first so CSS layers register before any component styles.
import '@/styles/app.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createAuth0 } from '@auth0/auth0-vue'

import router from '@/router'
import App from '@/App.vue'
import { i18n } from '@/i18n'
import { setupChartJS } from '@/lib/chartSetup'

// Register Chart.js scales and plugins once at boot (plan 07-05 LiveChart depends on this).
setupChartJS()

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(
    createAuth0({
        domain: import.meta.env.VITE_AUTH0_DOMAIN,
        clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
            scope: 'openid profile email futures:read futures:write futures:approve',
        },
        // D-04 — silent-refresh iframe only; NO localStorage refresh token in v1.
        // cacheLocation defaults to 'memory' which is correct per D-04.
        // (Peer customer-service/feature-crm uses 'localstorage' — intentionally NOT copied here.)
    }),
)
app.use(router)
app.mount('#app')
